var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFamLogoWhite = function SvgFamLogoWhite(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 160,
    height: 40,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.426 10.171v6.858H43.46V27.2H19.426V40H0V0h46.835v10.171h-27.41Z",
    fill: "#F8F9FA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M76.975 33.029H55.08L51.211 40H31.457L56.644 0H75.74l25.188 40H80.844l-3.869-6.971Zm-5.35-9.715-5.597-10.057-5.598 10.057h11.195Z",
    fill: "#F8F9FA"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m142.303 40-.165-18.229L129.627 36.4h-8.56l-12.512-14V40H90.858V0h15.969l18.767 21.314L143.867 0h15.968L160 40h-17.697Z",
    fill: "#F8F9FA"
  })));
};
export default SvgFamLogoWhite;